import { types } from "mobx-state-tree";
import { StringModel } from "../../mobxDataModels/stringModel";

export const Mk8sDraftProviderAzureAMIReadOnlyModel = types.model({
  recommended: types.optional(types.string, ""),
  reference: types.maybe(
    types.model({
      publisher: types.optional(types.string, ""),
      offer: types.optional(types.string, ""),
      sku: types.optional(types.string, ""),
      version: types.optional(types.string, ""),
    }),
  ),
});

export const Mk8sDraftProviderAzureAMIModel = types
  .model({
    recommended: types.optional(types.string, ""),
    reference_publisher: types.optional(StringModel, () =>
      StringModel.create({ label: "Publisher", isRequired: true }),
    ),
    reference_offer: types.optional(StringModel, () => StringModel.create({ label: "Offer", isRequired: true })),
    reference_sku: types.optional(StringModel, () => StringModel.create({ label: "SKU", isRequired: true })),
    reference_version: types.optional(StringModel, () => StringModel.create({ label: "Version", isRequired: true })),
    type: types.optional(types.enumeration(["recommended", "reference", "none"]), "none"),
  })
  .actions((self) => ({
    setType(newType: "recommended" | "reference" | "none") {
      self.type = newType;
    },
    setRecommended(value: string) {
      self.recommended = value;
    },
  }));
